import React from 'react';

// Material-UI
import { styled } from '@mui/material/styles';
import { Paper, CircularProgress } from '@mui/material';
import { CancelButton, SubmitButton } from 'components/ui/buttons';

export default function FormSubmitBar(props) {
    const { unsavedChanges, loading, onCancel, onSubmit, disabled } = props;

    return (
        <EditModeActions elevation={24}>
            <>
                {loading ? (
                    <LoadingSpinner color="secondary" size={34} />
                ) : (
                    <>
                        <CancelButton disabled={!unsavedChanges || disabled} onClick={onCancel}>
                            Cancel
                        </CancelButton>
                        <SubmitButton disabled={!unsavedChanges || disabled} onClick={onSubmit}>
                            Save Changes
                        </SubmitButton>
                    </>
                )}
            </>
        </EditModeActions>
    );
}

const LoadingSpinner = styled(CircularProgress)(({ theme }) => ({
    marginLeft: theme.spacing(2),
}));

const EditModeActions = styled(Paper)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 'auto',
    left: 230,
    bottom: 0,
    right: 0,
    height: theme.spacing(7),
    borderRadius: 0,
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
        left: 0,
        right: 0,
    },
}));
